/* StatusComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./StatusRenderer");

class StatusComponent extends DefaultColumnComponent {
    constructor(configOptions) {
        super(configOptions);
        if (configOptions) {
            this._statusState = configOptions || "unknown";
        } else {
            this._statusState = "unknown";
        }
        this._statusViewDefs = {
            unknown: {
                elemType: "base-icon-gl",
                iconName: "common.unknown",
                title: "Unknown",
                addInvalidAttr: false
            },
            success: {
                elemType: "base-icon-gl",
                iconName: "common.success",
                title: "Success",
                addInvalidAttr: false
            },
            failure: {
                elemType: "base-icon-gl",
                iconName: "common.failed",
                title: "Failed",
                addInvalidAttr: true
            }
        };

        this._renderer = new Renderer(this);
        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._statusState = undefined;
        });

        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    _triggerUserCellAction(eventData) {
        this.emit("UserCellAction", eventData);
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    setStatusState(newVal) {
        this._statusState = newVal;
        this.emit("StatusStateChanged", this._statusState);
    }
    getStatusState() {
        return this._statusState;
    }
    getStatusViewDefs() {
        return this._statusViewDefs;
    }

    static SortFunction(a, b) {
        let valueMap = {
            unknown: 0,
            success: 1,
            failure: 2
        };

        let aVal = valueMap[a[1]],
            bVal = valueMap[b[1]];

        if (aVal > bVal) {
            return 1;
        }
        if (aVal < bVal) {
            return -1;
        }
        return 0;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = StatusComponent;
